<p-card>
  <ng-template #title>
    <p class="title-text"><strong>Email</strong></p>
    <span class="form-field">
      <input pInputText id="email" class="login-input" type="text" placeholder="abc123@calvin.edu" [formControl]="email"
        (keyup)="handleKeyUp($event)" />
    </span>

    <p class="title-text"><strong>Password</strong></p>
    <app-password-input [control]="password" (keyup)="handleKeyUp($event)"> </app-password-input>
  </ng-template>

  <ng-template #subtitle>
    @if (invalidLogin) {
    <p class="error-msg">Invalid email or password!</p>
    }
  </ng-template>

  <p-button class="login-btn" label="Login" (click)="login()" [loading]="isLoggingIn" />

  <ng-template #footer>
    @if (forgotPasswordPath) {
    <a [routerLink]="forgotPasswordPath" routerLinkActive="active" class="forgot-password-text"><strong>Forgot
        Password</strong></a>
    }
  </ng-template>
</p-card>